import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getProductsToManage = async () => {
  const data = await getDataWithDotNet(ajaxEndpoints.PRODUCTS_PENDING_APPROVAL);
  return data.data;
};

export default function useManageProductsData({ email }) {
  // The email is a query identifier here
  return useQuery([{ email }, "getProductsToManage"], getProductsToManage);
}
